<template>
    <ul class="nav_breadcrumbs">
        <li>
            <router-link to="/modules/home">{{lang.LBL_HOME}}</router-link>
        </li>
       
        <li>
            <router-link to="/modules/applicationbudgets">{{lang.LBL_VIEW_BUDGETS}}</router-link>
        </li>
        <li>
            <router-link to="#" data-bs-toggle="modal" data-bs-target="#budgetReviewModal">{{lang.LBL_BUDGET_REVIEWS}}</router-link>
        </li>
    </ul>
</template>

<script>
    import lang from "@/views/modules/ApplicationBudgets/language/en";
    export default {
        name: "breadcrumbs",
        data() {
            return {
                lang: [],
            }
        },
        mounted() {
            this.lang = lang;
        },

    }
</script>